import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  YAxis,
  Label,
  ReferenceLine,
  Customized,
} from "recharts";
import { useContext, useMemo } from "react";
import "./depth-graph/depth-graph.css";

import { DataContext } from "src/contexts/DataContext";
import { useGraphHover } from "src/contexts/GraphHoverContext";
import { useChannelData, useEDFDataParams } from "src/contexts/EDFDataContext";

function HoverLine({ channelData }) {
  const { hoverTimestep } = useGraphHover();
  const hoverLineIndex = useMemo(() => {
    if (channelData && hoverTimestep) {
      const intervalMs = Math.round(
        (channelData.timespan[1] - channelData.timespan[0]) /
          channelData.data.length
      );
      return Math.round((hoverTimestep - channelData.timespan[0]) / intervalMs);
    }
  }, [channelData, hoverTimestep]);
  return (
    <ReferenceLine
      x={hoverLineIndex}
      stroke="white"
      strokeOpacity={1}
      strokeWidth={1}
    />
  );
}

export function EDFGraph() {
  const { selectedChannel } = useContext(DataContext);
  const { data: channelData, isLoading } = useChannelData();
  const { limit } = useEDFDataParams();
  
  const chartData = useMemo(
    () =>
      channelData?.data?.map((item, index) => ({
        [selectedChannel]: item,
        index,
      })),
    [channelData?.data, selectedChannel]
  );

  const loadingDataMock = useMemo(() => {
    return Array.from({ length: 100 }, (_, index) => ({
      [selectedChannel]: 0,
      index,
    }));
  }, [selectedChannel]);

  if (!channelData && !isLoading) return;

  const fontAttribs = { fill: "white" };

  return (
    <div className="stats-panel">
      <ResponsiveContainer width="100%" height={120}>
        <LineChart
          margin={{
            top: 15,
            right: 15,
            left: 15,
            bottom: 10,
          }}
          data={isLoading ? loadingDataMock : chartData}
          dataKey={selectedChannel}
          style={fontAttribs}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <YAxis dataKey={selectedChannel} tick={fontAttribs} domain={isLoading ? [-1, 1] : ["auto", "auto"]}>
            <Label
              style={{
                textAnchor: "middle",
                fontSize: "130%",
                fill: "white",
              }}
              position="left"
              angle={270}
              value={selectedChannel}
            />
          </YAxis>
          <Line
            type="monotone"
            dataKey={selectedChannel}
            fillOpacity={isLoading ? 0.5 : 1}
            stroke="Pink"
            dot={false}
            name="x"
            strokeDasharray={isLoading ? "3 3" : "none"}
            isAnimationActive={limit < 10001}
          />
          <Customized component={HoverLine} channelData={channelData} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
